import { E_NAV_KEY, E_ROUTER_NAME } from '@pharmsnap/pharmsnap-web/types/enum'
import { createWebTitle } from '@pharmsnap/pharmsnap-web/utils/business/document-title'
import type { RouteConfig } from 'vue-router'

const meta = {
  activeKey: E_NAV_KEY.SEARCH_HISTORY,
  title: createWebTitle('历史记录', 'Search History'),
}

const savedSearchMeta = {
  activeKey: E_NAV_KEY.SAVED_SEARCH,
  title: createWebTitle('我的检索式', 'My Search Queries'),
}

export default [
  {
    path: `search-history`,
    name: E_ROUTER_NAME.SEARCH_HISTORY,
    component: () => import('@pharmsnap/pharmsnap-web/views/searchHistory/SearchHistory'),
    meta,
  },
  {
    path: `saved-search`,
    name: E_ROUTER_NAME.SAVED_SEARCH,
    component: () => import('@pharmsnap/pharmsnap-web/views/savedSearch/SavedSearch'),
    meta: savedSearchMeta,
  },
] as RouteConfig[]
